import { Skeleton } from '@/components/ui/Skeleton.tsx';
import { cn } from '@/lib/utils.ts';

interface RichTextEditorSkeletonProps {
  className?: string;
}

export const RichTextEditorSkeleton = ({
  className,
}: RichTextEditorSkeletonProps) => (
  <div
    className={cn(
      'overflow-hidden rounded-md border border-neutral-200 bg-basic-white',
      className,
    )}
  >
    {/* Toolbar */}
    <div className="flex items-center gap-1.5 border-b border-neutral-200 px-2 py-1.5">
      <Skeleton className="h-7 w-7" />
      <Skeleton className="h-7 w-7" />
      <Skeleton className="h-7 w-7" />
      <Skeleton className="h-7 w-7" />
      <Skeleton className="mx-1 h-6 w-px" />
      <Skeleton className="h-7 w-24" />
      <Skeleton className="mx-1 h-6 w-px" />
      <Skeleton className="h-7 w-7" />
      <Skeleton className="h-7 w-7" />
    </div>
    {/* Content area */}
    <div className="space-y-2 px-4 py-3 min-h-[300px]">
      <Skeleton className="h-4 w-3/4" />
      <Skeleton className="h-4 w-5/6" />
      <Skeleton className="h-4 w-2/3" />
    </div>
  </div>
);
